import StatsTable from './StatsTable';
export default StatsTable;
